<template>
  <div class="container">
    <svg viewBox="0 0 960 300">
      <symbol id="s-text">
        <text text-anchor="middle" x="50%" y="80%">aye</text>
        <text text-anchor="middle" x="52%" y="80%">aye</text>
      </symbol>

      <g class="g-ants">
        <use xlink:href="#s-text" class="text-copy"></use>
        <use xlink:href="#s-text" class="text-copy"></use>
        <use xlink:href="#s-text" class="text-copy"></use>
        <use xlink:href="#s-text" class="text-copy"></use>
        <use xlink:href="#s-text" class="text-copy"></use>
      </g>
    </svg>
  </div>
</template>

<style scoped>
.container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-59%, -50%);
  /* overflow: hidden; */
}
svg {
  display: block;
  margin-inline: auto;
  font: 25rem "Arial";
  width: 480px;
  height: 150px;
}
.text-copy {
  fill: none;
  stroke: rgb(222, 218, 218);
  stroke-dasharray: 6% 29%;
  stroke-width: 5px;
  stroke-dashoffset: 0%;
  animation: stroke-offset 5.5s infinite linear;
}

.text-copy:nth-child(1) {
  /* stroke: #4d163d; */
  stroke: rgb(177, 177, 172);
  stroke: #c4cbdf;
  animation-delay: -1;
}

.text-copy:nth-child(2) {
  /* stroke: #840037; */
  stroke: rgb(208, 208, 206);
  stroke: #b0bad5;
  animation-delay: -2s;
}

.text-copy:nth-child(3) {
  /* stroke: #bd0034; */
  stroke: rgb(100, 100, 100);
  stroke: #3a5395;
  animation-delay: -3s;
}

.text-copy:nth-child(4) {
  /* stroke: #bd0034; */
  stroke: rgb(138, 138, 136);
  stroke: #4e64a0;
  animation-delay: -4s;
}

.text-copy:nth-child(5) {
  /* stroke: #fdb731; */
  stroke: rgb(49, 49, 48);
  stroke: #8998bf;
  animation-delay: -5s;
}

@keyframes stroke-offset {
  100% {
    stroke-dashoffset: -35%;
  }
}
</style>
